module.exports = __webpack_public_path__ + "img/icon-empty-mute.4b075549.png";